import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/services/api';
import { portalEnvironment } from '../../../../environments/environment';
import { PortalUserInfo } from '../models/auth.model';
import { PortalPatientProfileResponse } from '../../profile/models/profile.model';
import { withPatientParam } from '@portal_utils/with-patient-param';

@Injectable({ providedIn: 'root' })
export class PortalAuthInfoApi extends BaseApiService<PortalUserInfo> {
  constructor() {
    super(portalEnvironment.apiUrl);
  }

  async getAuthInfo(): Promise<PortalUserInfo> {
    return this.get<PortalUserInfo>('/user');
  }

  /**
   * Create a resource for fetching patient profile info (shared across dashboard, navigation, profile).
   */
  createProfileResource(patientGuid: () => string | null) {
    return this.createDynamicGetResource<PortalPatientProfileResponse>(
      () => {
        const guid = patientGuid();
        if (!guid) return null;
        return withPatientParam('/patient-profile/patient', guid);
      },
      () => ({ patientGuid: patientGuid() })
    );
  }
}
